import { createAction } from '@reduxjs/toolkit';

export const accountSessionsEvent = createAction('account sessions event');
